import { createAPI } from '@common'
export default {
  getRRSites: (config) => createAPI('customEncryptApiName-1/0w20ss0tjuft', 'get', config),
  POSTRRMCArticles: (config) => createAPI('customEncryptApiName-1/w20ss0NDBsujdmft', 'POST', config),
  getRRMCArticlesRevoke: (config) =>
    createAPI('customEncryptApiName-1/w20ss0NDBsujdmft0Sfwplf', 'get', config),
  // 获取根栏目
  getColumnRoot: (config) => createAPI('customEncryptApiName-1/0w20dpmvnot0sppu', 'get', config), // type=0&ch=1&siteID=1
  // 获取子栏目
  getColumns: (config) => createAPI('customEncryptApiName-1/0w20dpmvnot', 'get', config),
  // 获取用户有权限的站点
  getMainSites: (config) =>
    createAPI('customEncryptApiName-1/0w20nbjo0tjuft', 'get', config, { isHideErrorMessage: true }),
  // 获取用户当前的站点
  getMainSitesCurrent: (config) =>
    createAPI('customEncryptApiName-1/0w20nbjo0tjuft0dvssfou', 'get', config),
  // 获取稿件详情
  getRRMCArticlesDetail: (config) =>
    createAPI('customEncryptApiName-1/0w20ss0NDBsujdmft0efubjm', 'get', config),
  // 权限
  getArticleActions: (config) =>
    createAPI('customEncryptApiName-1/0w20bsujdmf0bdujpot', 'get', config),
  POSTRRMCArticlesRevoke: (config) =>
    createAPI('customEncryptApiName-1/w20ss0NDBsujdmft0sfwplf', 'POST', config),
  // 按指定的文档类型读子文件夹树
  getE5FoldersByDocType: (config) =>
    createAPI('customEncryptApiName-1/0f60gpmefst0cz0epdUzqf', 'get', config),
  // 根据folder获取子文件夹树
  getE5FoldersChildren: (config) =>
    createAPI('customEncryptApiName-1/0f60gpmefst0dijmesfo', 'get', config),
  // 选用——publishcenter
  postRRCommandReceiverSelect: (config, vconfig) =>
    createAPI('customEncryptApiName-1/w20ss0dpnnboe0sfdfjwfs0tfmfdu', 'POST', config, vconfig),
  // 选用——云端稿库
  postRRArticlesCopy: (config, vconfig) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20ssbsujdmft0dpqz',
        'POST',
        { params: config.data },
        { hubForward: true, hub: 'e5/hub', ...vconfig }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20ssbsujdmft0dpqz',
        'POST',
        { params: config.data },
        vconfig
      )
    }
  },
  // 获取当前版本信息
  getDeployVersion: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20efqmpz0wfstjpo', 'get', config, {
        hubForward: true,
        hub: 'e5/hub'
      })
    } else {
      return createAPI('customEncryptApiName-1/0w20efqmpz0wfstjpo', 'get', config, {})
    }
  },
  // 读子系统列表（所有第三方系统的）
  getAdminClientsTenants: (config) =>
    createAPI('customEncryptApiName-1/0w20benjo0dmjfout0ufobout', 'GET', config),
  // 获取每日热文
  getRRMCArticlesHot: (config) =>
    createAPI('customEncryptApiName-1/0w20ss0NDBsujdmft0ipu', 'GET', config),
  // 获取选用热文
  getRRMCArticlesHotIssue: (config) =>
    createAPI('customEncryptApiName-1/0w20ss0NDBsujdmft0ipu0jttvf', 'GET', config),
  // 移除
  postArticlesRemove: (config) =>
    createAPI('customEncryptApiName-1/0w20bsujdmft0sfnpwf', 'post', config),
  // 移动
  postArticlesMove: (config) => createAPI('customEncryptApiName-1/0w20bsujdmft0npwf', 'post', config),
  // 保存转发记录
  postRRMCArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0w20ss0NDBsujdmft0gpsxbse', 'post', config),
  // 当前用户信息
  getUsersInfo: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0w20vtfst0jogp', 'GET', config, vconfig),
  // 学习强国入库状态查询接口
  postArtcleXuexiStatus: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0w20bsujdmft0yvfyj0tubuvt', 'post', config),
  // 学习强国推送接口
  postArtcleXuexiPush: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0w20bsujdmft0yvfyj0qvti', 'post', config, {
      isHideErrorMessage: true
    })
}
